module.exports = __webpack_public_path__ + "static/media/button-round-arrow-left.04ee862f.svg";